import { useSelector } from "react-redux";
import useAirUserRoles from "utils/AuthUtils";

/**
 * Whether ESG-admin-only UI should currently render: the user IS an ESG Admin AND
 * they haven't toggled admin features off via the header icon (EsgAdminViewToggle).
 * Use this (not raw isESGAdmin) for admin-only VIEW gating. Authorization/permission
 * checks (what a user is ALLOWED to do) should keep using isESGAdmin directly - this
 * toggle is a view preference, not a permission change.
 */
export default function useEsgAdminFeaturesVisible() {
  const { isESGAdmin } = useAirUserRoles();
  const showAdminFeatures = useSelector((state) => state.adminView?.showAdminFeatures ?? true);
  return isESGAdmin && showAdminFeatures;
}
